import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    h: 2,
    m: 0,
    s: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    let endTime = sessionStorage.getItem('countdown_end');
    if (!endTime) {
      endTime = (Date.now() + 2 * 60 * 60 * 1000).toString();
      sessionStorage.setItem('countdown_end', endTime);
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = parseInt(endTime!) - now;
      if (distance <= 0) {
        clearInterval(interval);
        setIsExpired(true);
      } else {
        setTimeLeft({
          h: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          m: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          s: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className={`fixed bottom-0 left-0 right-0 bg-verde-oscuro border-t border-dorado/30 p-[12px_20px] z-[100] transition-transform duration-400 ease-in-out flex flex-wrap items-center justify-center gap-5 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-288">
      <div className="text-[15px] md:text-[14px] text-white/80 font-medium" data-id="element-289">
        Protocolo Digestivo 72 Horas™
      </div>
      <button onClick={() => {
      const el = document.getElementById('checkout-btn');
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - window.innerHeight / 2 + 30;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }} className="text-[15px] md:text-[14px] font-semibold text-dorado-claro border border-dorado/40 px-5 py-2.5 rounded-[4px] transition-all hover:bg-dorado/10 hover:border-dorado/60" data-id="element-290">
        Ver oferta ↓
      </button>
    </div>;
}